import { createApi } from '@reduxjs/toolkit/query/react';
import { z } from 'zod';
import { baseQuery } from './baseQuery';
import { validateResponse } from './validateResponse';

export const FeatureFlagsSchema = z.object({
    HomeV3:              z.boolean(),
    ProfessionalsV3:     z.boolean(),
    OrganizationsV3:     z.boolean(),
    ExUsProfessionalsV3: z.boolean(),
    TargetingV3:         z.boolean(),
    ExhibitsDisplaysV3:  z.boolean(),
    AdminV3:             z.boolean(),
    // .default(false): newest flag — tolerate an old backend build that
    // predates this field instead of failing the whole flags response.
    ExhibitsDisplaysBroadAccess: z.boolean().default(false),
    OrganizationsDermTeamsAccess: z.boolean().default(false),
    AffiliationsEditDermTeamsAccess: z.boolean().default(false),
});

export type FeatureFlags = z.infer<typeof FeatureFlagsSchema>;

export const featuresApi = createApi({
    reducerPath: 'featuresApi',
    baseQuery,
    endpoints: (builder) => ({
        getFeatureFlags: builder.query<FeatureFlags, void>({
            query: () => 'api/v3/features',
            transformResponse: validateResponse(FeatureFlagsSchema),
            // Keep in cache for the session; re-fetch only on mount
            keepUnusedDataFor: 300,
        }),
    }),
});

export const { useGetFeatureFlagsQuery } = featuresApi;
